<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3" v-if="!isFromDashBoard">{{ 'Cron Time Analysis' }}</strong>
          <h4 class="card-title m-0 float-left" v-if="isFromDashBoard">{{ 'Cron Time Analysis' }}</h4>
        </div>
        <div class="col-md-1" v-if="!isFromDashBoard">
          <download :tableId="'not-update-cron-analysis'" :fileName="'not-update-cron-analysis'"></download>
        </div>
        <div class="col-md-1" v-if="!isFromDashBoard">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-3">
          <div class="form-group">
            <datepicker :input-class="'form-control'" :format="'dd-MM-yyyy'" v-model="ddate"
              @selected="getSelDate($event)"></datepicker>
          </div>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table id="not-update-cron-analysis" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field' + field.title">{{ field.title }}</th>
              <th v-if="actions.length > 0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in fillableData" v-bind:key="'row' + index">
              <td>
                <span>{{ (index + 1) + (perPage * (current_page - 1)) }}</span>
              </td>
              <td v-for="field in tableFields" v-bind:key="field.name + index">
                <span v-if="field.type === 'date'">{{ getDateTime(row[field.name]) }}</span>
                <span v-else-if="field.type === 'number'">{{ getFixed(row[field.name]) }}</span>
                <span v-else>{{ row[field.name].toString() }}</span>
              </td>
              <td v-if="actions.length > 0">
                <div class="action-btn-wrapper">
                  <a style="margin:1px 4px" class="btn btn-sm btn-small" :class="action.btnClass"
                    v-for="action in actions" v-bind:key="'action' + action.tooltip"
                    @click.prevent="action.callback(row, index, $event)">
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length == 0">
            <tr>
              <td :colspan="(tableFields.length + actions.length + 1)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="pull-right" v-if="totalPages > 1">
          <ul v-if="this.totalPages != 1" class="pagination">
            <li :class="{ disabled: prevDisabled }" class="page-item">
              <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
            </li>
            <li :class="{ disabled: prevDisabled }" class="page-item">
              <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
            </li>
            <li v-for="(page, index) in pages" v-bind:key="index + page" class="page-item"
              :class="(current_page == page) ? 'active' : ''">
              <a class="page-link" @click.prevent="goToPage(page)" href="#">{{ page }}</a>
            </li>
            <li :class="{ disabled: nextDisabled }" class="page-item">
              <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
            </li>
            <li :class="{ disabled: nextDisabled }" class="page-item">
              <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
            </li>
          </ul>
        </div>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import Datepicker from "vuejs-datepicker";
export default {
  components: { Datepicker },
  mixins: [commonMixins],
  name: "notUpdateCronAnalysis",
  props: ["isFromDashBoard"],
  created() {
    this.url = this.apiUrl;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = 1);
    // this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData();
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      apiUrl: "notUpdateCronAnalysis",
      pageType: "notUpdateCronAnalysis",
      ddate: new Date(), //.setDate(new Date().getDate() - 1),
      perPage: 100,
      company: {},
      actions: [],
      tableFields: [
        {
          name: "cron_name",
          title: "Cron Title",
          type: 'string'
        },
        {
          name: "date",
          title: "Date",
          type: 'date'
        },
        {
          name: "function_list",
          title: "Function List",
          type: 'list'
        },
        /* {
          name: "end_time",
          title: "End Time",
          type: 'time'
        },
        {
          name: "time_duration",
          title: "Duration (In Mins)",
          type: 'number'
        } */
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      page: 1,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: []
    };
  },
  methods: {
    fetchData() {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = {
          date: myself.getDate(myself.ddate),
          pageid: myself.pageToLoad
        };
        http.post(this.url, params, function (error, response) {
          console.log(response);
          myself.fillableData = response.final_data;
          myself.current_page = 1;//myself.pageToLoad;
          myself.totalPages = 1;//response.total_pages;
          myself.prevDisabled = myself.pageToLoad == 1;
          myself.nextDisabled = myself.current_page == myself.totalPages;
          myself.isLoading = false;
          //myself.fillableData[0].function_list.push("New function");
          // set 5 pages to show
          //console.log("current", myself.current_page);
          let i = 5;
          let page = myself.current_page - 2;
          if (page <= 0) page = 1;
          myself.pages = [];
          while (i) {
            myself.pages.push(parseInt(page));
            if (myself.totalPages <= page) break;
            page++;
            i--;
          }
          console.log("PAges", myself.pages);
          // } else {
          //   console.log(error);
          // }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      // if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData();
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    getSelDate(e) {
      console.log("Selected date", e);
      this.ddate = e;
      this.fetchData();
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/activity-logs/not-update-cron-analysis.vue